<template>
  <div class="object-transfer-dialog">
    <gs-modal v-model="visible" :before-close="beforeClose" :before-confirm="beforeConfirm"
      :title="isEdit ? name + '-对象传输' : '新建' + '-对象传输'" :has-form="true" class="object-transfer-dialog-modal"
      width="40%" @close="close" @cancel="close" @confirm="handleConfirm">
      <gs-tabs v-model="activeName" type="content-tab">
        <gs-tab-pane label="常规" name="General">
          <div class="general-form">
            <gs-form label-width="50px" label-position="left" gap="small">
              <gs-form-item label="名称" prop="name">
                <gs-input ref="nameInput" v-model="name" />
              </gs-form-item>

              <gs-form-item label="描述" prop="Description">
                <gs-input v-model="description" />
              </gs-form-item>
            </gs-form>
          </div>
        </gs-tab-pane>
        <gs-tab-pane label="传输" name="transfer">
          <div class="alarm-form">
            <gs-form label-width="50px" label-position="left" gap="small">
              <fieldset>
                <legend>传输源</legend>
                <gs-form-item label="对象" prop="fromObject" label-width="50px">
                  <gs-input v-model="showFromObject" :disabled="showFromObject === ''" style="width:84%" />
                  <gs-button @click="add('fromObject')">...</gs-button>
                </gs-form-item>
                <!--  <gs-form-item
                  label="属性"
                  prop="fromProperty"
                >
                  <gs-select
                    v-model="form.fromProperty"
                    class="doc-select"
                  >
                    <gs-option
                      v-for="item in referencedOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </gs-select>
                </gs-form-item> -->
              </fieldset>
              <fieldset>
                <legend>传输目标</legend>
                <gs-form-item label="对象" prop="toObject" label-width="50px">
                  <gs-input v-model="showToObject" style="width:84%" />
                  <gs-button @click="add('toObject')">...</gs-button>
                </gs-form-item>
                <!-- <gs-form-item
                  label="属性"
                  prop="toProperty"
                >
                  <gs-select
                    v-model="form.toProperty"
                    class="doc-select"
                  >
                    <gs-option
                      v-for="item in referencedOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </gs-select>
                </gs-form-item> -->
              </fieldset>
            </gs-form>
          </div>
        </gs-tab-pane>

        <gs-tab-pane label="时间设置" name="timeControl">
          <div class="object-form">
            <gs-form label-width="100px" label-position="left" gap="small">
              <gs-form-item label="事件触发对象" prop="triggingObject">
                <gs-input v-model="showEventTriggingObject" :disabled="showEventTriggingObject === ''"
                  style="width:84%" />
                <gs-button @click="add('triggingObject')">...</gs-button>
              </gs-form-item>
              <gs-form-item label="开始时间" prop="startTime">
                <gs-checkbox v-model="enableStartTime" />
                <gs-date-picker v-model="form.startTime" :default-time="defaultTime" :disabled="!enableStartTime"
                  type="date-time" input-type="input" />
              </gs-form-item>
              <gs-form-item label="激活" prop="activate">
                <gs-select v-model="form.activate" class="doc-select">
                  <gs-option v-for="item in activateOptions" :key="item.value" :label="item.label"
                    :value="item.value" />
                </gs-select>
              </gs-form-item>
            </gs-form>
          </div>
          <div class="time-form">
            <gs-form label-width="100px" label-position="left" gap="small">
              <!-- <gs-form-item
                label="传输周期"
                prop="transferPeriod"
              >
                <gs-time-picker
                  v-model="form.transferPeriod"
                  :default-time="defaultTime"
                  format="mm:ss"
                  input-type="input"
                />
                <label style="fontSize:16px">(mm:ss)</label>
              </gs-form-item>-->
              <gs-form-item label="更新间隔" prop="updateInterval">
                <gs-time-picker v-model="form.updateInterval" :default-time="defaultTime" format="mm:ss"
                  input-type="input" />
                <label style="fontSize:16px">(mm:ss)</label>
              </gs-form-item>
              <gs-form-item label="最小变化" prop="minChange">
                <gs-input v-model="form.minChange" controls-position="right" size="mini" style="width: 70px;" />
              </gs-form-item>
            </gs-form>
          </div>
        </gs-tab-pane>
      </gs-tabs>
      <span slot="footer" class="dialog-footer">
        <gs-button type="primary" size="mini" @click="handleConfirm">确 定</gs-button>
        <gs-button type="primary" size="mini" @click="beforeClose">取 消</gs-button>
        <gs-button type="primary" size="mini" @click="dialogHelp = true">帮 助</gs-button>
      </span>
    </gs-modal>
    <gs-modal v-model="visibleAdd" :title="'添加' + addTitle" class="alarmReceiver-select" @close="closeAdd"
      @confirm="handleConfirmAdd">
      <div class="treeList">
        <gs-tree @node-click="treeClick" v-if="visibleAdd" ref="tree" :data="dataList" :props="props"
          :disable-node="true" :leaf-checkbox-only="true" :node-key="'id'" show-checkbox @check-change="checkEvent" />
      </div>
    </gs-modal>
    <gs-modal height="200px" title="帮助-对象传输" v-model="dialogHelp" class="my-test-class" width="42%"
      :before-close="handleCloseHelp">
      <span class="tab">常规</span><br>
      <hr />
      <span class="tit">名称：</span><span class="txt">趋势日志对象的名称</span><br>
      <span class="tit">描述：</span><span class="txt">该对的详细描述</span><br>
      <span class="tab">传输</span><br>
      <hr />
      <span class="tit">传输源</span><span class="txt"></span><br>
      <span class="tit">对象：</span><span class="txt">在此处选择要传输的值的对象</span><br>
      <span class="tit">属性：</span><span class="txt">选择要发送其值的所选对象的属性</span><br>
      <span class="tit">传输目标</span><span class="txt"></span><br>
      <span class="tit">对象：</span><span class="txt">在此处选择要将值传送到接收的对象</span><br>
      <span class="tit">属性：</span><span class="txt">选择要接收对象的属性</span><br>
      <span class="tab">时间设置</span><br>
      <hr />
      <span class="tit">事件触发对象：</span><span
        class="txt">选择将要触发对象传输的事件对象,**激活**应设置为**自动**.此处的对象选择只能是时间事件对象或时间事件列表对象.</span><br>
      <span class="tit">开始时间：</span><span class="txt">选择对象传输将要开始的时间</span><br>
      <span class="tit">激活：</span><span class="txt">关闭、开启、自动</span><br>
      <span class="tit">更新间隔：</span><span class="txt">在此处将以分钟和秒为单位指定数据的传输间隔</span><br>
      <span class="tit">最小变化：</span><span
        class="txt">​在此处将定义值的最小变化.如果传输者和传输目标的值的绝对值小于最小变化,那么该次值传输不进行传输.如果最小变化设置为零(0),那么每次值传输的情况都会进行传输.</span><br>

      <span></span>
      <span slot="footer" class="dialog-footer">

        <!--<el-button @click="dialogHelp = false">取 消</el-button>
    <el-button type="primary" @click="dialogHelp = false">确 定</el-button>-->
      </span>
    </gs-modal>

  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import service from '../../service/leftService.js'
import moment from 'moment'
export default {
  data() {
    return {
      dialogHelp: false,
      isEdit: false,
      activeName: 'General',
      name: '',
      description: '',
      props: {
        label: 'name',
        disabled: 'type:folder'
      },
      form: {
        fromObject: null,
        fromProperty: 'value',
        toObject: null,
        toProperty: 'value',
        triggingObject: null,
        startTime: moment(),
        activate: '',
        transferPeriod: null,
        minChange: 0,
        updateInterval: null
      },
      visibleAdd: false,
      dataList: [],
      selection: [],
      showFromObject: '',
      showToObject: '',
      showEventTriggingObject: '',
      referencedOptions: [
        {
          value: 'value',
          label: '值'
        }
      ],
      activateOptions: [
        {
          value: 'manOff',
          label: '手动-关闭'
        },
        {
          value: 'manOn',
          label: '手动-开启'
        },
        {
          value: 'auto',
          label: '自动'
        }
      ],
      defaultTime: moment(),
      addTitle: '',
      enableStartTime: true,
      tableData: []
    }
  },
  computed: {
    ...mapState({
      visible: 'objectTransferShow',
      objectData: 'objectInfo',
      nodeData: 'nodeTree'
    })
  },
  watch: {
    'form.fromObject': function () {
      this.showFromObject = this.form.fromObject ? this.form.fromObject.name : ''
    },
    'form.toObject': function () {

      this.showToObject = this.form.toObject ? this.form.toObject.name : ''
    },
    'form.triggingObject': function () {
      this.showEventTriggingObject = this.form.triggingObject ? this.form.triggingObject.fullName : ''
    },
    showFromObject() {
      if (this.form.fromObject && this.showFromObject !== this.form.fromObject.name) {
        this.form.fromObject = null
      }
    },
    showToObject() {
      if (this.form.toObject && this.showToObject !== this.form.toObject.name) {
        this.form.toObject = null
      }
    },
    showEventTriggingObject() {
      if (this.form.triggingObject && this.showEventTriggingObject !== this.form.triggingObject.fullName) {
        this.form.triggingObject = null
      }
    },
    visible() {
      if (this.visible) {
        setTimeout(() => {
          this.$refs.nameInput.focus()
        }, 100)
        this.activeName = 'General'
        console.log(this.objectData)
        if (JSON.stringify(this.objectData) !== '{}' && this.objectData.type === 'objectTransfer') {
          this.form = this.objectData.attribute ? this.objectData.attribute : {}
          this.description = this.objectData.description ? this.objectData.description : ''
          this.name = this.objectData.name ? this.objectData.name : ''
          this.form.startTime = moment(this.form.startTime)
          this.form.transferPeriod = moment(this.form.transferPeriod)
          this.form.updateInterval = moment(this.form.updateInterval)
          this.isEdit = true
        } else {
          this.form = {
            fromObject: null,
            fromProperty: 'value',
            toObject: null,
            toProperty: 'value',
            triggingObject: null,
            startTime: moment(),
            activate: '',
            transferPeriod: null,
            minChange: 0,
            updateInterval: null
          }
          this.description = ''
          this.name = ''
          this.isEdit = false
        }
      }
    }
  },
  methods: {
    ...mapMutations({
      close: 'OBJECT_TRANSFER_HIDE'
    }),
    changeFun(val) {
      this.form.toObject = val[0]
      this.showToObject = val[0].name
    },
    // 节点被点击时的回调
    treeClick(data) {
      data.data.id
    },
    beforeConfirm(e, done) {
      if (this.name === null || this.name === '') {
        this.$Message.warning('名称不能为空!')
        return
      }
      if (this.form.fromObject === null || this.form.toObject === null) {
        this.$Message.warning('传输对象或目标对象必须填写!')
        return
      }
      if (this.form.fromObject.id === this.form.toObject.id) {
        this.$Message.warning('传输对象与目标对象不能一样!')
        return
      }
      if (this.form.fromObject.type !== this.form.toObject.type) {
        switch (this.form.fromObject.type) {
          case 'value_Analog':
            if (this.form.toObject.type !== 'AnalogInput' && this.form.toObject.type !== 'AnalogOutput') {
              this.$Message.warning('传输对象与目标对象类型必须一致!')
              return
            }
            break
          case 'value_Multistate':
            this.$Message.warning('传输对象与目标对象类型必须一致!')
            return
          case 'value_Binary':
            if (this.form.toObject.type !== 'BinaryInput' && this.form.toObject.type !== 'BinaryOutput') {
              this.$Message.warning('传输对象与目标对象类型必须一致!')
              return
            }
            break
          case 'value_String':
            this.$Message.warning('传输对象与目标对象类型必须一致!')
            return
          case 'BinaryInput':
          case 'BinaryOutput':
            if (this.form.toObject.type !== 'value_Binary') {
              this.$Message.warning('传输对象与目标对象类型必须一致!')
              return
            }
            break
          case 'AnalogInput':
          case 'AnalogOutput':
            if (this.form.toObject.type !== 'value_Analog') {
              this.$Message.warning('传输对象与目标对象类型必须一致!')
              return
            }
            break
          default:
            break
        }
      }
      // done(false)可以阻止modal关闭
      done()
    },
    handleConfirm() {
      let transferPeriod = new Date(this.form.transferPeriod)
      transferPeriod = (transferPeriod.getMinutes() * 60 + transferPeriod.getSeconds()) * 1000
      let updateInterval = new Date(this.form.updateInterval)
      updateInterval = (updateInterval.getMinutes() * 60 + updateInterval.getSeconds()) * 1000
      let fromObject = this.form.fromObject ? this.form.fromObject.id : ''
      let toObject = this.form.toObject ? this.form.toObject.id : ''
      let triggingObject = this.form.triggingObject ? this.form.triggingObject.id : ''
      let startTime = this.form.startTime.valueOf()
      if (this.objectData.id && this.objectData.type === 'objectTransfer') {
        let param = {
          'id': this.objectData.id,
          'name': this.name,
          'type': this.objectData.type,
          'value': this.objectData.value,
          'parentId': this.objectData.parentId,
          'description': this.description,
          'attribute': {
            'fromObject': fromObject,
            'fromProperty': this.form.fromProperty,
            'toObject': toObject,
            'toProperty': this.form.toProperty,
            'triggingObject': triggingObject,
            'startTime': startTime,
            'activate': this.form.activate,
            'transferPeriod': transferPeriod,
            'updateInterval': updateInterval,
            'minChange': this.form.minChange
          }
        }
        service.renamePoint(param).then(res => {
          this.$Message.success('修改成功')
          this.close()
        }).catch(err => {
          this.$Message.error(err.message)
        })
      } else {
        let param = {
          'name': this.name,
          'type': 'objectTransfer',
          'parentId': this.objectData.id,
          'description': this.description,
          'attribute': {
            'fromObject': fromObject,
            'fromProperty': this.form.fromProperty,
            'toObject': toObject,
            'toProperty': this.form.toProperty,
            'triggingObject': triggingObject,
            'startTime': startTime,
            'activate': this.form.activate,
            'transferPeriod': transferPeriod,
            'updateInterval': updateInterval,
            'minChange': this.form.minChange
          }
        }
        service.newAddPoint(param).then(res => {
          this.$Message.success('添加成功')
          this.close()
        }).catch(err => {
          this.$Message.error(err.message)
        })
      }
    },
    beforeClose(e, done) {
      // done(false)可以阻止modal关闭
      this.close()
    },
    add(input) {

      this.dataList = []
      let _this = this
      this.visibleAdd = true
      switch (input) {
        case 'fromObject':
          this.addTitle = '传输者'
          service.getTree('Point', this.nodeData.id).then(res => {
            if (res[0] !== null) {
              this.dataList = res
            }
            if (_this.form.fromObject !== null) {
              setTimeout(() => {
                _this.$refs.tree.setChecked(this.form.fromObject.id, true)
              }, 0)
            }
          })
          break
        case 'toObject':
          this.addTitle = '传输目标'
          service.getTree('Point', this.nodeData.id).then(res => {
            if (res[0] !== null) {
              this.dataList = res
            }
            if (this.form.toObject !== null) {
              setTimeout(() => {
                _this.$refs.tree.setChecked(this.form.toObject.id, true)
              }, 0)
            }
          })
          break
        case 'triggingObject':
          this.addTitle = '事件触发对象'
          service.getTree('EventAndTimeChart').then(res => {
            if (res[0] !== null) {
              this.dataList = res
            }
            if (_this.form.triggingObject !== null) {
              setTimeout(() => {
                _this.$refs.tree.setChecked(this.form.triggingObject.id, true)
              }, 0)
            }
          })
          break

        default:
          break
      }
    },
    closeAdd() {
      this.visibleAdd = false
    },
    checkEvent(node, isSelect, halfSelect) {
      // console.log(node)
      // console.log(isSelect)
      // console.log(halfSelect)
      // if (node.type !== 'alarmReceiverEmail' && node.type !== 'timeChart' && node.type !== 'userGroupAlarm') {
      //   console.log(node)
      //   this.$Message.error('此节点为目录，无法被选择')
      //   this.$refs.tree.setChecked(node.id, false)
      // }
    },
    getSelection(selection, row) {
      this.selection = selection
    },
    handleConfirmAdd() {
      let _this = this
      let array = _this.$refs.tree.getCheckedNodes(true)
      let id = array[0].data.id
      if (this.addTitle === "传输目标") {
        service.getRightList(id).then(res => {
          console.log(res)
          this.tableData = res
        })
      }
      switch (this.addTitle) {
        case '传输者':
          if (array != null && array.length > 1) {
            this.$Message.warning('最多只能选择一个')
            return
          }
          this.form.fromObject = array[0].data ? array[0].data : null
          break
        case '传输目标':
          if (array != null && array.length > 1) {
            this.$Message.warning('最多只能选择一个')
            return
          }
          this.form.toObject = array[0].data ? array[0].data : null
          break
        case '事件触发对象':
          if (array != null && array.length > 1) {
            this.$Message.warning('最多只能选择一个')
            return
          }
          this.form.triggingObject = array[0].data ? array[0].data : null
          break

        default:
          break
      }
      this.visibleAdd = false
    },
    unique(arr, name) {
      var hash = {}
      return arr.reduce(function (item, next) {
        hash[next[name]] ? '' : hash[next[name]] = true && item.push(next)
        return item
      }, [])
    },
    handleCloseHelp() {
      this.dialogHelp = false
    }
  }
}
</script>
<style lang="scss">
.object-transfer-dialog {
  &-modal {
    .gs-select {
      width: 70%;
    }

    fieldset {
      padding: 12px;
      border-radius: 5px;
      border: solid 2px #d9d9d9;
    }

    .gs-radio-group {
      line-height: 24px;
    }

    .limit {
      display: flex;
      width: 100%;
    }

    .page-checkbox {
      margin-bottom: 24px;
    }

    .form-item-alarmReceiverList {
      height: 200px;
      overflow: auto;
      margin-bottom: 12px;
      padding: 12px;
      border: solid 1px #d9d9d9;
      border-radius: 1px;
    }

    .checkbox {
      margin-bottom: 12px;
    }

    .bottom-btn {
      text-align: center;
    }

    .object-form {
      border-bottom: solid 1px #d9d9d9;
    }

    .time-form {
      margin-top: 12px;

      .gs-time-picker-popover.gs-popover .gs-time-spinner-wrapper:first-child {
        display: none;
      }
    }

    .gs-tabs-content {
      position: static;
      overflow: hidden;
      padding: 16px 0;
    }
  }
}

.treeList {
  height: 300px;
  overflow: auto;
  margin-bottom: 12px;
  padding: 12px;
  border: solid 1px #d9d9d9;
  border-radius: 1px;
}

.el-input__inner {
  border: solid 1px #d9d9d9;
}

.tit {
  color: #ffffff;
}

.txt {
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/objectTransfer/objectTransfer.vue